module.exports = __webpack_public_path__ + "assets/img/icon-light.a240174f.svg";